import { useEffect, useState } from "react";
import { useMounted, useIdcTokenVerifyEndPointLazyQuery } from "@/hooks";
import routes from "@/lib/routes";

export function useRequireIdcLogin() {
  const [result, setResult] = useState(false);
  const mounted = useMounted();

  const [idcTokenVerify, { data, loading, called, error }] =
    useIdcTokenVerifyEndPointLazyQuery({
      fetchPolicy: "no-cache",
    });

  // 2. Lancement de la requête au montage
  useEffect(() => {
    if (mounted && !called) {
      idcTokenVerify();
    }
  }, [mounted, called, idcTokenVerify]);

  useEffect(() => {
    if (!mounted || !called) return;

    if (loading) return;

    if (error || !data) {
      window.location.replace(routes.login);
      return;
    }

    setResult(true);
  }, [mounted, called, loading, data, error]);

  return result;
}
